<p>dealer-become-partner works!</p>
